import { render, staticRenderFns } from "./GtcColumnComponent.vue?vue&type=template&id=54cf393c&"
import script from "./GtcColumnComponent.vue?vue&type=script&lang=ts&"
export * from "./GtcColumnComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54cf393c')) {
      api.createRecord('54cf393c', component.options)
    } else {
      api.reload('54cf393c', component.options)
    }
    module.hot.accept("./GtcColumnComponent.vue?vue&type=template&id=54cf393c&", function () {
      api.rerender('54cf393c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/InProcessing/GtcColumnComponent.vue"
export default component.exports